import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import SimpleTest from "./components/SimpleTest";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

/* global document, Office, module, require, HTMLElement */

// Suppress harmless ResizeObserver errors
const resizeObserverErrorHandler = (e: ErrorEvent) => {
  if (e.message && (
      e.message.includes('ResizeObserver loop') ||
      e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded')) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
};
window.addEventListener('error', resizeObserverErrorHandler);

// Also suppress unhandled promise rejections related to ResizeObserver
window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
    e.preventDefault();
  }
});

const title = "Scholar Sync";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
function render() {
  console.log("Rendering app...");
  
  // Render the full app with Fluent UI
  root?.render(
    <FluentProvider theme={webLightTheme}>
      <App title={title} />
    </FluentProvider>
  );
}

// Check if Office.js is available
if (typeof Office !== "undefined") {
  console.log("Office.js found, waiting for it to be ready...");
  Office.onReady(() => {
    console.log("Office.js is ready!");
    render();
  });
} else {
  console.log("Office.js not found, rendering anyway (dev mode)");
  // In dev mode or browser preview, render immediately
  render();
}

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
